import React, { FunctionComponent } from "react";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { ValidationPanel } from "../../components/document/validation/ValidationPanel";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { DocumentNonRootError } from "../../components/generic/DocumentNonRootError";
import { CPMVersions, isCpmVersionLess } from "../../utils/helpers/ApiResolver";

export const ValidationPage: FunctionComponent = () => {
  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_VALIDATION}
      errorComponent={<UnauthorizedError />}
      isAuthorizedOverride={({ originalAuthorization }) => {
        if (isCpmVersionLess(CPMVersions.CPM_VERSION36_0)) return true;
        return originalAuthorization;
      }}
    >
      <CoRetrieveDocumentData shouldFetchDocumentPart={true}>
        {({ coObject, documentPart }) => {
          if (!coObject?.documentId) return <DocumentNotValidError />;
          if (!documentPart.root) return <DocumentNonRootError />;
          return <ValidationPanel documentPart={documentPart} />;
        }}
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
